import React, { useState, useLayoutEffect, useEffect, useRef } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import api from "../../services/api";
import TextInputComponent from "../../components/textinput";
import ButtonComponent from "../../components/button";
import Spinner from "../../components/spinner";
import { useToaster } from "../../context/ToasterContext";
import "../../styles/payment-webview.scss";
import { ReactComponent as SuccessCircleFilledIcon } from "../../assets/icons/check-circle.svg";
import { ReactComponent as FailedCircleFilledIcon } from "../../assets/icons/close-circle.svg";
import { ReactComponent as DollarCircleIcon } from "../../assets/icons/dollar-circle.svg";
import { fetchShopDetailsByShopLink, getOrderStatusApiCall, getListActivitiesApiCall, formatAmountInLocale, getMinimumAmountForCurrency, returnShortCodeOfPaymentMethod, poolMoneyAgainForSomeone_extended, goBackToEditNameScreen_extended } from "../../utils/global";
import useGlobalState from "../../utils/global";
import { loadScript, loadCSS } from "../../utils/loadScript";
import useInitFcmRegisterProcess from "../../utils/registerFcmPushNotificationsForOrderActivities";
import useIfOrderSessionTimedout from "../../utils/checkIfOrderSessionTimedout";
import { useShopDetailsContext } from '../../context/ShopDetailsContext';
import PoweredByComponent from "../../webview-components/powered-by";
import CopyAndShareLinksComponent from "../../webview-components/copy-and-share-links";
import LiveActivitiesComponent from "../../webview-components/live-activities";
import PoolCompletedDiv from "../../webview-components/pool-completed-div";
import PaymentSuccessfulDiv from "../../webview-components/payment-successful-div";
import PaymentScreenTopDiv from "../../webview-components/payment-screen-top-div";
import PaymentNameScreen from "../../webview-components/payment-name-screen";
import PaymentAmountScreen from "../../webview-components/payment-amount-screen";
import PaymentOboScreen from "../../webview-components/payment-obo-screen";
import FcmNotificationPermissionPopup from "../../webview-components/fcm-notification-permission-popup";
import PaymentSessionTimedOutComponent from "../../webview-components/payment-session-timedout";
import MerchantLogoHeader from "../../webview-components/merchant-logo-header";
import SingleProductDetailWhilePayingPopup from "../../webview-components/single-product-detail-while-paying-popup";

const TyroPaymentLink = () => {
  useEffect(() => {
    document.title = "Payment - SuperCheckout";
  }, []);

  let { id, shop } = useParams();
  //console.log("useParams id: " + id);
  //console.log("useParams shop: " + shop);

  const sc_theme = localStorage.getItem("sc_theme") || "light";

  const [fcmTrigger, setFcmTrigger] = useState(null);

  const { new_activity_sound, pool_completion_sound, set_confetti_play_init_bool, poolProgressBarPercent, setPoolProgressBarPercent, getListActivitiesResult, set_getListActivitiesResult, screenName, setScreenName, amountPaidSoFar, setAmountPaidSoFar, amountLeft, setAmountLeft, noOfSplitPaymentsDone, setNoOfSplitPaymentsDone, isOrderTimeSensitive, set_isOrderTimeSensitive, orderTimedOut, set_orderTimedOut, name, setName, step, setStep, order_type, set_order_type, oboName, setOboName, superpay, set_superpay, this_orderIsRefundedBool, set_this_orderIsRefundedBool } = useGlobalState(id, 'tyro-payment');

  let this_copyAndShareLinkUrl = window.location.href;

  const [searchParams] = useSearchParams();
  
  let total_pax = searchParams.get("total_pax") || "0";
  let cart_items = searchParams.get("cart_items") || "";
  let obo_ui = searchParams.get("obo_ui") || "";

  const [noOfPax, setNoOfPax] = useState(total_pax);

  let this_checkoutMethod = "pax_based";
  if(cart_items !== '' && cart_items !== null){
    cart_items = cart_items.split(',');

    this_checkoutMethod = "cart_based";

    this_copyAndShareLinkUrl = window.location.origin +"/checkout/"+ id;
  }

  const [copyAndShareLinkUrl, set_copyAndShareLinkUrl] = useState(this_copyAndShareLinkUrl);

  const [checkoutMethod, set_checkoutMethod] = useState(this_checkoutMethod);
  const [splitAmountToBePaid, set_splitAmountToBePaid] = useState("");

  const { toaster } = useToaster();
  const navigate = useNavigate();

  let payment_link_for_userid_from_localstorage = localStorage.getItem("payment_link__"+ id);

  const [isDropinLoaded, setIsDropinLoaded] = useState(false);
  const [clientSecret, set_clientSecret] = useState(null);
  const [shopDetails, setShopDetails] = useState({});

  const [currentOrderData, set_currentOrderData] = useState([]);
  const [confirmPaymentApi_loading, setConfirmPaymentApi_loading] = useState(false);
  const [walletPaymentBtnSubmit_loading, set_walletPaymentBtnSubmit_loading] = useState(false);
  const [getOrderStatusResult, set_getOrderStatusResult] = useState([]);

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const { setShopDetailsContext } = useShopDetailsContext();

  const [animation, setAnimation] = useState("active");
  const steps = [
    { id: "name" },
    { id: "amount" },
    { id: "payment" },
    { id: "on_behalf_of_name" },
  ];

  const tyroInstance = useRef(null);

  const lightStyleProps = {
    bodyPadding: "0px 0px",
    bodyMinWidth: 250,
    bodyMaxWidth: 980,
    labelPosition: 'block',
    walletPaymentsButtonsPadding: '0px',
    walletPaymentsButtonsMargin: '0px',
    labelPadding: '10px 0px',
    buttonBorderRadius: "8px",
    applePayButton: {
      buttonStyle: 'black',
      buttonBorderRadius: "8px"
    },
    googlePayButton: {
      buttonStyle: 'black',
      buttonBorderRadius: "8px"
    }
  };

  const darkStyleProps = {
    bodyBackgroundColor: '#151516',
    bodyPadding: "0px 0px",
    bodyMinWidth: 250,
    bodyMaxWidth: 980,
    labelPosition: 'block',
    walletPaymentsButtonsPadding: '0px',
    walletPaymentsButtonsMargin: '0px',
    labelPadding: '10px 0px',
    buttonBorderRadius: "8px",
    applePayButton: {
      buttonStyle: 'white-outline',
      buttonBorderRadius: "8px"
    },
    googlePayButton: {
      buttonStyle: 'white',
      buttonBorderRadius: "8px"
    }
  };

  useEffect(() => {
    loadScript(`https://pay.connect.tyro.com/v1/tyro.js`, 'tyro-js');
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (window.Tyro) {
        clearInterval(interval);

        let liveMode_bool = false;
        if (window.location.hostname.includes('supercheckout.ai') && window.location.hostname.includes('pay-sandbox-')){
          liveMode_bool = true; //sandbox
        }
        else if (window.location.hostname.includes('supercheckout.ai')){
          liveMode_bool = true; //production
        }
        
        const tyro = window.Tyro({
          liveMode: liveMode_bool
        });

        tyroInstance.current = tyro;
      }
    }, 100);
  }, []);

  //fetching shop details by shoplink
  useEffect(() => {
    const fetchShopDetails = async () => {
      try {
        const response = await fetchShopDetailsByShopLink(id);

        setShopDetails(response);

        setFcmTrigger({ id: id, shop: response.shop_name });

        if(typeof response.meta_data?.timeout !== 'undefined' && response.meta_data?.timeout !== null && response.meta_data?.timeout !== 0){
          set_isOrderTimeSensitive(true);
        }

        setShopDetailsContext(prev => ({
          ...prev,
          user_image: response.user_image,
          shop_name: response.shop_name,
          meta_data: response.meta_data
        }));

        getOrderDetailsApiCall();
      } catch (err) {
        console.log(err);
      }
    };

    fetchShopDetails();
  }, []);

  const getOrderDetailsApiCall = async () => {
    try {
      setLoading(true);

      const response = await getOrderStatusApiCall(id);
      let firstPaymentDoneBool = false;
      if(response.percentage_done > 0){
        firstPaymentDoneBool = true;
      }

      //here "sharelink=false" should be only for 1st link
      let createOrderApiCallResponse = await api.get(
        `sdk/orders/get-order-data/${id}/${noOfPax}?sharelink=${firstPaymentDoneBool}`
      );
      console.log(createOrderApiCallResponse);

      //setLoading(false);

      if (
        (createOrderApiCallResponse.status === 200 ||
          createOrderApiCallResponse.status === 201) &&
        createOrderApiCallResponse.data
      ) {
        if (createOrderApiCallResponse.data) {
          if(createOrderApiCallResponse.data.cart_data.cart_display.length > 1){
            set_order_type("fixed_cart");
          }
          else if(createOrderApiCallResponse.data.cart_data.cart_display.length === 1){
            if(createOrderApiCallResponse.data.cart_data.cart_display[0].quantity > 1){
              set_order_type("fixed_cart");
            }
            else if(createOrderApiCallResponse.data.order_type !== 'fixed_cart'){
              set_order_type(createOrderApiCallResponse.data.order_type);
            }
            else if(order_type === ''){
              if(noOfPax === '1'){
                set_order_type("fixed_payforme");
              }
              else if(noOfPax === '0'){
                set_order_type("variable_price");
              }
              else if(noOfPax === '-1'){
                set_order_type("variable_self");
              }
              else{
                set_order_type("fixed_price");
              }
            }
          }
          else{
            set_order_type(createOrderApiCallResponse.data.order_type);
          }

          set_currentOrderData(createOrderApiCallResponse.data);
        }
      } else {
        if (
          createOrderApiCallResponse.data.errorMessage &&
          createOrderApiCallResponse.data.errorMessage.length
        ) {
          toaster.error(createOrderApiCallResponse.data.errorMessage);
        } else {
          toaster.error("Something went wrong");
        }
      }
    } catch (error) {
      setLoading(false);
      
      console.log("Exception: ", error);

      toaster.error("Something went wrong");
    }
  };

  //upon change in currentOrderData
  useEffect(() => {
    if(currentOrderData && currentOrderData.cart_data){
      if(order_type === 'fixed_cart'){
        if(currentOrderData.cart_data){
          if(currentOrderData.cart_data.cart_events){
            let total = cart_items.reduce((sum, id) => {
              return currentOrderData.cart_data.cart_events[id] ? sum + parseFloat(currentOrderData.cart_data.cart_events[id].amount) : sum;
            }, 0);
            
            set_splitAmountToBePaid(total.toFixed(2));
          }
        }
      }
      else if(order_type === 'fixed_price' || order_type === 'fixed_payforme'){
        console.log(currentOrderData);
        set_splitAmountToBePaid(currentOrderData.amount);
      }
      else if((order_type === 'variable_price' || order_type === 'variable_self') && screenName === "payment"){
        if(step === 2){
          console.log("step set 1");
          setStep(1);
        }
      }

      if(currentOrderData.payment_method !== 'tyro'){
        window.location.href = "/"+ returnShortCodeOfPaymentMethod(currentOrderData.payment_method) +"/"+ id +""+ window.location.search;

        return;
      }

      const getOrderStatusApiCall_init = async (id) => {
        try {
          const response = await getOrderStatusApiCall(id);

          if(response.order_type !== 'None'){
            set_order_type(response.order_type);
          }

          setShopDetailsContext(prev => ({
            ...prev,
            order_created_at: response.created_at
          }));

          set_getOrderStatusResult(response);

          setPoolProgressBarPercent(response.percentage_done);

          if(typeof response.pax !== 'undefined' && response.pax !== null && response.pax !== '' && response.pax !== 0){
            setNoOfPax(response.pax);
          }

          let amount_so_far = parseFloat(response.total_amount) - parseFloat(response.amount_left);
          setAmountPaidSoFar(parseFloat(amount_so_far).toFixed(2));
          setAmountLeft(parseFloat(response.amount_left).toFixed(2));

          if(response.percentage_done === 100 || response.status === 'completed'){
            setStep(2);

            setScreenName("pool_completed");

            //window.manager.addConfetti();
            //set_confetti_play_init_bool(true);
          }
  
          getListActivitiesApiCall_init(id);
        } catch (err) {
          console.log(err);
        }
      };
      getOrderStatusApiCall_init(id);

      const getListActivitiesApiCall_init = async (id) => {
        try {
          const response = await getListActivitiesApiCall(id);
  
          setLoading(false);

          set_getListActivitiesResult(response.activities);

          let is_refunded = false;
          for(let i=0; i < response.activities.length; i++){
            if(response.activities[i].order_status === 'refunded'){
              set_this_orderIsRefundedBool(true);
              is_refunded = true;
            }

            if(response.activities[i].order_status === 'authorized'){
              setNoOfSplitPaymentsDone((prev) => prev + 1);

              if(obo_ui === 'yes'){
                setScreenName("payment");

                setStep(3);

                const url = new URL(window.location.href);
                url.searchParams.delete('obo_ui');
                window.history.replaceState({}, document.title, window.location.origin + window.location.pathname + url.search.replace('&obo_ui=yes',''));
              }
              else if(response.activities[i].user_id === payment_link_for_userid_from_localstorage){
                if(checkoutMethod === 'cart_based'){
                  //pending
                }
                else{
                  setScreenName("payment_success");
                  
                  setStep(2);
                }
              }
            }
          }

          if(response.status === 'completed' && is_refunded === false){
            window.manager.addConfetti();
            set_confetti_play_init_bool(true);
          }
        } catch (err) {
          console.log(err);
        }
      };
    }
  }, [currentOrderData]);

  useEffect(() => {
    if (poolProgressBarPercent && poolProgressBarPercent === 100) {
      setScreenName("pool_completed");
    }
  }, [poolProgressBarPercent]);

  useEffect(() => {
    if(!loading && currentOrderData){
      setTimeout(function(){
        if(screenName === 'payment'){
          if(currentOrderData.total_amount && shopDetails.user_country){
            mountPaymentElements(currentOrderData);
          }
        }
      }, 50);

      if(screenName === 'payment' && step === 2 && (order_type === 'variable_price' || order_type === 'variable_self')){
        
        setStep(1);
      }
    }
  }, [loading, currentOrderData, screenName, shopDetails]);

  const mountPaymentElements = (orderData) => {
    if(name !== null && name !== ''){
      if(order_type === 'variable_price' || order_type === 'variable_self'){

      }
      else{
        createPaymentIntentApiCall(orderData);
      }
    }
  }

  const createPaymentIntentApiCall = async (orderData) => {
    try {
      let requestData = {
        order_id: id,
        currency: shopDetails.user_currency,
        amount: splitAmountToBePaid,
        total_amount: orderData.total_amount,
        user_name: name,
        order_type: order_type,
        success_redirect_url: window.location.href +"&redirect_status=payment_success",
        failure_redirect_url: window.location.href +"&redirect_status=payment_failure"
      };

      if(order_type === 'fixed_price' || order_type === 'fixed_payforme'){
        requestData['total_pax'] = noOfPax;
      }
      else if(order_type === 'fixed_cart' && cart_items !== null){
        requestData['cart_items'] = cart_items;
      }

      if(payment_link_for_userid_from_localstorage){
        requestData['user_id'] = payment_link_for_userid_from_localstorage;
      }

      if(oboName !== ''){
        requestData['obo_name'] = oboName;
      }

      try {
        const createChargeApiResponse = await api.post(
          `tyro/payments/create-charge`,
          requestData
        );
        
        //set user_id in localstorage against current payment link - start
        if(createChargeApiResponse.data.user_id){
          localStorage.setItem("payment_link__"+ id, createChargeApiResponse.data.user_id);
        }
        //set user_id in localstorage against current payment link - end

        const paySecret = await createChargeApiResponse.data.paySecret;
        console.log(paySecret);
        await tyroInstance.current.init(paySecret);

        const styleProps = sc_theme === 'dark' ? darkStyleProps : lightStyleProps;

        const payForm = tyroInstance.current.createPayForm({
          theme: sc_theme === 'dark' ? 'dark' : 'default',
          styleProps,
          options: {
            applePay: {
              enabled: true,
              totalLabel: shopDetails.shop_name,
              supportedNetworks: ['visa', 'mastercard', 'amex', 'jcb', 'maestro'],
            },
            googlePay: {
              enabled: true,
              merchantInfo: {
                merchantName: shopDetails.shop_name,
                merchantId: shopDetails.shop_name,
              },
              supportedNetworks: ['visa', 'mastercard', 'amex', 'jcb', 'maestro'],
            },
            creditCardForm: {
              enabled: true,
              supportedNetworks: ['visa', 'mastercard', 'amex', 'jcb', 'maestro'],
            }
          }
        });

        await payForm.inject("#tyro-pay-form");

        payForm.setReadyListener(() => {
          setIsDropinLoaded(true);
        });

        payForm.setWalletPaymentCompleteListener((paymentType, error) => {
          set_walletPaymentBtnSubmit_loading(true);

          if(error) {
            const { type, errorMessage, errorCode, gatewayCode } = error;
            // handle errors here
            switch (type) {
              case "CLIENT_VALIDATION_ERROR":
                return showClientValidationError(errorMessage);
              case "SERVER_VALIDATION_ERROR":
                return showServerValidationError(errorMessage, errorCode, gatewayCode);
              case "CARD_ERROR":
                return showCardError(errorMessage, errorCode, gatewayCode);
              case "SERVER_ERROR":
                return showGenericError(errorMessage, errorCode, gatewayCode);
              default:
                return console.error("Unknown error", error);
            }
          } else {
            showPaymentResult();

            set_walletPaymentBtnSubmit_loading(false);
          }
        });

        setConfirmPaymentApi_loading(false);
      } catch (error) {
        console.log("Error creating charge: "+ error);

        setConfirmPaymentApi_loading(false);
      }
    } catch (error) {
      console.log("Exception: ", error);

      setConfirmPaymentApi_loading(false);

      //toaster.error("Something went wrong");
    }
  };

  const showClientValidationError = (msg) => console.log(`Client Validation Error: ${msg}`);
  const showServerValidationError = (msg, code, gatewayCode) => console.log(`Server Validation Error: ${msg}`);
  const showCardError = (msg, code, gatewayCode) => console.log(`Card Error: ${msg}`);
  const showGenericError = (msg, code, gatewayCode) => console.log(`Server Error: ${msg}`);
  const showProcessing = () => console.log("Payment is processing...");
  const showSuccess = () => {
    console.log("Payment successful!");
    
    setScreenName("payment_success");
    setStep(2);
    
    setOboName("");
  };
  const showFail = () => console.log("Payment failed.");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!tyroInstance.current) return;

    try {
      setConfirmPaymentApi_loading(true);

      await tyroInstance.current.submitPay();
      await showPaymentResult();
    } catch (error) {
      setConfirmPaymentApi_loading(false);

      const { type, errorMessage, errorCode, gatewayCode } = error;

      switch (type) {
        case "CLIENT_VALIDATION_ERROR":
          return showClientValidationError(errorMessage);
        case "SERVER_VALIDATION_ERROR":
          return showServerValidationError(errorMessage, errorCode, gatewayCode);
        case "CARD_ERROR":
          return showCardError(errorMessage, errorCode, gatewayCode);
        case "SERVER_ERROR":
          return showGenericError(errorMessage, errorCode, gatewayCode);
        default:
          return console.error("Unknown error", error);
      }
    }
  };

  const showPaymentResult = async () => {
    set_walletPaymentBtnSubmit_loading(false);
    setConfirmPaymentApi_loading(false);

    const payRequest = await tyroInstance.current.fetchPayRequest();

    switch (payRequest.status) {
      case "PROCESSING":
        return showProcessing();
      case "SUCCESS":
        return showSuccess();
      case "FAILED":
        return showFail();
      default:
        return console.warn("Unknown payment status", payRequest.status);
    }
  };

  useInitFcmRegisterProcess(fcmTrigger?.id, fcmTrigger?.shop);

  const orderSessionTimedout_bool = useIfOrderSessionTimedout(getOrderStatusResult?.created_at, shopDetails?.meta_data?.timeout);
  if(orderSessionTimedout_bool === true && orderTimedOut !== true && isOrderTimeSensitive === true && screenName !== "pool_completed"){
    set_orderTimedOut(orderSessionTimedout_bool);
  }

  return (
    <div className="payment-page-wrapper">
      {loading && <Spinner />}

      {!loading && 
        <>
          {orderTimedOut === true && 
            <div>
              <PaymentSessionTimedOutComponent></PaymentSessionTimedOutComponent>
            </div>
          }
          {orderTimedOut !== true && 
            <div>
              <div className="mt-2 mb-3">
                <MerchantLogoHeader shop_name={shopDetails.shop_name} user_image={''}></MerchantLogoHeader>
              </div>

              <div className="payment-form-wrapper">
                <div className="form-wrapper text-start">
                  <div className={`typeform-container pt-2 activeScreenName_${screenName}`}>
                    {steps.map((s, index) => {
                      if (s.id === "name") {
                        return <div
                          key={s.id}
                          className={`step ${
                            step === index ? `active ${animation}` : ""
                          }`}
                        >
                          <PaymentNameScreen order_type={order_type} loading={loading} shopDetails={shopDetails} currentOrderData={currentOrderData} splitAmountToBePaid={splitAmountToBePaid} getOrderStatusResult={getOrderStatusResult} name={name} setName={setName} setStep={setStep} createPaymentIntentApiCall={createPaymentIntentApiCall} mountPaymentElements={null} pageName="tyro-payment"></PaymentNameScreen>
                        </div>
                      }
                      if (s.id === "amount") {
                        return <div
                          key={s.id}
                          className={`step ${
                            step === index ? `active ${animation}` : ""
                          }`}
                        >
                          <PaymentAmountScreen order_type={order_type} loading={loading} shopDetails={shopDetails} currentOrderData={currentOrderData} splitAmountToBePaid={splitAmountToBePaid} getOrderStatusResult={getOrderStatusResult} setStep={setStep} createPaymentIntentApiCall={createPaymentIntentApiCall} mountPaymentElements={null} set_splitAmountToBePaid={set_splitAmountToBePaid} setScreenName={setScreenName} pageName="tyro-payment"></PaymentAmountScreen>
                        </div>
                      }
                      if (s.id === "payment") {
                        return <div
                          key={s.id}
                          className={`step ${
                            step === index ? `active ${animation}` : ""
                          }`}
                        >
                          {screenName === "payment" &&
                            <div>
                              <PaymentScreenTopDiv loading={loading} shopDetails={shopDetails} name={name} order_type={order_type} currentOrderData={currentOrderData} splitAmountToBePaid={splitAmountToBePaid} setName={setName} setStep={setStep} id={id} superpay={superpay}></PaymentScreenTopDiv>

                              <div className="tab-content pt-0" id="paymentTabsContent">
                                <div className="tab-pane fade show active" id="payTab" role="tabpanel" aria-labelledby="pay-tab">
                                  <div className="mt-4 mb-3">
                                    <div className="whiteCard text-center">
                                      {walletPaymentBtnSubmit_loading && <Spinner />}
                                      <form id="pay-form" onSubmit={handleSubmit}>
                                        <div id="tyro-pay-form">
                                          {/* Tyro.js injects the Pay Input Fields */}
                                        </div>
                                        {isDropinLoaded &&
                                          <ButtonComponent
                                            type="submit"
                                            id="pay-form-submit"
                                            className="btn btn-primary btn-pool-shadow btn-pool-full"
                                            disabled={confirmPaymentApi_loading}
                                            label={confirmPaymentApi_loading ? "Confirming payment..." : "Pay"}
                                            size="md"
                                            variant="primary"
                                          ></ButtonComponent>
                                        }
                                      </form>
                                      {!isDropinLoaded &&
                                        <p className="note">Fetching payment methods! Please wait...</p>
                                      }
                                    </div>
                                  </div>
                                </div>
                                <div className="tab-pane fade" id="shareTab" role="tabpanel" aria-labelledby="share-tab">
                                  {superpay === 'true' &&
                                    <div className="mb-4">
                                      <CopyAndShareLinksComponent order_type={order_type} link_url={copyAndShareLinkUrl} view_mode="inline"></CopyAndShareLinksComponent>
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                          }
                          {screenName === "payment_success" &&
                            <PaymentSuccessfulDiv order_type={order_type} name={name} copyAndShareLinkUrl={copyAndShareLinkUrl} id={id} shop={shop} checkoutMethod={checkoutMethod} setScreenName={setScreenName} getOrderDetailsApiCall={getOrderDetailsApiCall} setName={setName} setStep={setStep} pageName="tyro-payment"></PaymentSuccessfulDiv>
                          }
                          {screenName === "pool_completed" &&
                            <PoolCompletedDiv this_orderIsRefundedBool={this_orderIsRefundedBool}></PoolCompletedDiv>
                          }

                          <LiveActivitiesComponent
                            id={id}
                            screenName={screenName}
                            order_type={order_type}
                            currentOrderData={currentOrderData}
                            poolProgressBarPercent={poolProgressBarPercent}
                            noOfSplitPaymentsDone={noOfSplitPaymentsDone}
                            noOfPax={noOfPax}
                            shopDetails={shopDetails}
                            amountPaidSoFar={amountPaidSoFar}
                            amountLeft={amountLeft}
                            getListActivitiesResult={getListActivitiesResult}
                            this_orderIsRefundedBool={this_orderIsRefundedBool}
                          ></LiveActivitiesComponent>
                        </div>
                      }
                      if (s.id === "on_behalf_of_name") {
                        return <div
                          key={s.id}
                          className={`step ${
                            step === index ? `active ${animation}` : ""
                          }`}
                        >
                          <PaymentOboScreen order_type={order_type} loading={loading} shopDetails={shopDetails} currentOrderData={currentOrderData} splitAmountToBePaid={splitAmountToBePaid} getOrderStatusResult={getOrderStatusResult} setStep={setStep} createPaymentIntentApiCall={createPaymentIntentApiCall} mountPaymentElements={null} setScreenName={setScreenName} oboName={oboName} setOboName={setOboName} pageName="tyro-payment"></PaymentOboScreen>
                        </div>
                      }
                    })}
                  </div>
                </div>
              </div>

              {order_type !== 'fixed_cart' && currentOrderData.cart_data.cart_display.length > 0 &&
                <SingleProductDetailWhilePayingPopup cart_display={currentOrderData.cart_data.cart_display}></SingleProductDetailWhilePayingPopup>
              }

              <PoweredByComponent></PoweredByComponent>
              
              {screenName === "payment" && noOfSplitPaymentsDone > 0 && order_type !== 'fixed_payforme' && order_type !== 'variable_self' &&
                <CopyAndShareLinksComponent order_type={order_type} link_url={copyAndShareLinkUrl}></CopyAndShareLinksComponent>
              }
            </div>
          }
        </>
      }
    </div>
  );
};

export default TyroPaymentLink;